import { render, staticRenderFns } from "./AndamentoProjeto.vue?vue&type=template&id=84b0ca26&scoped=true&"
import script from "./AndamentoProjeto.vue?vue&type=script&lang=js&"
export * from "./AndamentoProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b0ca26",
  null
  
)

export default component.exports